import { useQuery } from '@tanstack/react-query';
import { api } from './api';

/**
 * Which parts of their CRM this client has been shared.
 *
 * Its own module rather than an export from RecordsPage, and that is not
 * tidiness. The sidebar needs this to decide which entries to draw, so it
 * imports it on every page — and importing it from the page pulled the whole
 * records screen, its table and its four column sets into the main bundle,
 * quietly undoing the route-level splitting the rest of this app relies on.
 *
 * Cached for five minutes. Sharing is changed by an admin in another console,
 * not by anything happening in this tab, so re-asking on every navigation buys
 * nothing.
 */

export interface CrmAccess {
  leads: boolean;
  contacts: boolean;
  companies: boolean;
  deals: boolean;
  canEdit: boolean;
}

export function useCrmAccess() {
  return useQuery({
    queryKey: ['client-crm-access'],
    queryFn: () => api.get<CrmAccess>('/crm/access'),
    staleTime: 5 * 60 * 1000,
  });
}
